import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "40px 0px",
  },
  title: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
    textAlign: "center",
  },
  title2: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
    marginTop: "60px !important",
    textAlign: "center",
  },
}));

const BioMetric = () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>
        Biometric Authentication
      </Typography>

      <p>
        You can use touch id ® or face id ® or fingerprint to log in to the ST Pay instead of your user id and pin. You must agree to the terms and conditions to enable touch id or face id or fingerprint. Please ensure that touch id or face id or fingerprint is also enabled on your device in order to enable it for the app.
      </p>

      <p>
        You acknowledge and agree that anyone with saved biometric information on your device will have authority to access your accounts and will be authorized to initiate transactions through the ST Pay.
      </p>

      <p>
        ST Pay advises you to review and confirm that all registered biometric information belongs to individuals with authority to initiate transactions on accounts accessed through the ST Pay. By agreeing below, ST Pay relies on your representation that anyone with registered biometric information is authorized to view information and transact on the accounts accessed through the ST Pay.
      </p>

      <p>
        ST Pay does not provide the touch id or face id technology and does not save or access your biometric information.
      </p>

      <p>
        ST Pay does not save your credentials to your device.
      </p>
    </div>
  );
};

export default BioMetric;
